"use strict";

export default {
  anzeigen: "17162a3d-0307-4522-b7e5-86b222917661",
  ausgenommen: "45418649-bfc3-4af3-a562-c2098658b555",
  noch_nicht_anzeigen: "f204a970-7186-44d3-ad87-792de39b0578"
};
